import { gql } from '@apollo/client';

export const GET_TIER2_TAGS = gql`
  query GetTier2Tags($where: Tier2TagsWhereInput, $distinctByTag: Boolean) {
    getCategoryTier2Tags(where: $where, distinctByTag: $distinctByTag) {
      categoryTier2
      tags {
        active
        uuid
        name
      }
    }
  }
`;

export type Tier2Tag = {
  categoryTier2: string;
  tags?: {
    active: boolean;
    uuid?: string | null;
    name?: string | null;
  } | null;
};

export type GetTier2TagsQueryResult = {
  getCategoryTier2Tags: Tier2Tag[];
};

export type GetTier2TagsQueryVariables = {
  where?: {
    categoryTier2?: string[];
    tags?: {
      active?: boolean;
    };
  };
  distinctByTag?: boolean;
};
